export const orderStatsData = {
  type: 'bar',
  data: {
    labels: ['Mercury', 'Venus', 'Earth', 'Mars', 'Jupiter', 'Saturn', 'Uranus', 'Neptune'],
    datasets: [
      { // another line graph
        label: 'Gross $ Orders',
        type: 'line',
        data: [4.8, 12.1, 12.7, 6.7, 139.8, 116.4, 50.7, 49.2],
        backgroundColor: ['rgba(255,255,255,1)'],
        borderColor: [
          '#36495d',
        ],
        borderWidth: 3
      },
      { // one line graph
        label: '# Orders',
        type: 'bar',
        data: [10, 20, 1, 2, 67, 62, 27, 14],
        backgroundColor: [],
        // borderColor: [
        //   '#36495d',
        // ],
        borderWidth: 3
      },
      // { // another line graph
      //   label: 'Avg $ per Order',
      //   data: [2, 18.1, 22.7, 3, 256.8, 300.4, 100.7, 123.2],
      //   backgroundColor: [
      //     'rgba(184, 32, 220, 1)', // Purple
      //   ],
      //   borderColor: [
      //     '#483d8b',
      //   ],
      //   borderWidth: 3
      // },
    ]
  },
  options: {
    maintainAspectRatio: false,
    responsive: true,
    lineTension: 1,
    events: ['click'],
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          padding: 25,
        }
      }]
    }
  }
}

export default orderStatsData;
